import { toggleModal } from '../actions';
import { Dialog, DialogContent, DialogTitle, DialogActions, Paper } from "@mui/material";
import Button from '../../Button';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { ModalInterface } from 'edocatbase/Modal';
import { Dispatch } from 'redux';
import { path } from 'ramda';
import Draggable from 'react-draggable';
import { Breakpoint } from '@mui/system/createBreakpoints/createBreakpoints';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

function PaperComponent(props) {
  return (
    <Draggable handle={`#form-dialog-title${props.counter}`} cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

interface ModalProps extends ModalInterface, ReduxComponentInterface {
  disableBackdropClick: boolean;
  disableEscapeKeyDown: boolean;
  disableDrag: boolean;
	PaperComponent: any;
  formOnly: boolean;
  isOpen: boolean;
  items?: any;
  maxWidth?: Breakpoint | false;
}

interface ModalState {
  instanceCounter: number;
}

class Modal extends window.React.PureComponent<ModalProps, ModalState> {
  private hideTimeout = 0;
  static counter: number = 0;

  static defaultProps = {
    disableBackdropClick: true,
    disableEscapeKeyDown: false,
    hideActionButtons: false,
    PaperComponent: null,
    fullScreen: false,
    fullWidth: false,
    formOnly: false,
    maxWidth: 'lg',
  };

  constructor(props) {
    super(props);
    this.state = {
      instanceCounter: Modal.counter++,
    };
  }

  componentDidUpdate(prevProps: Readonly<ModalProps>) {
    const { name } = this.props;
    
    // @ts-ignore
    if (!prevProps[name]?.isOpen && this.props[name]?.isOpen && this.props.hideTimeout) {
      this.hideTimeout = window.setTimeout(() => {
        this.handleClose();
      }, this.props.hideTimeout * 1000);
    }
  }

  handleClose = () => {
    const { actions, name, onClose } = this.props;
   // if(reason && reason === "backdropClick" ){ return; }
    // @ts-ignore
    const items = this.props[name]?.items;
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = 0;
    }

    if (onClose) {
      onClose();
    } else {
      actions.toggleModal(false, name, items, items?.formInstanceId);
    }
  };

  handleSubmit = () => {
    const { actions, name, onSubmit } = this.props;
    // @ts-ignore
    const items = this.props[name]?.items;
    if (onSubmit) onSubmit();
    actions.toggleModal(false, name, items, items?.formInstanceId);
  };

  render() {
    const {
      name,
      title,
      className,
      fullScreen,
      fullWidth,
      hideActionButtons,
      onSubmit,
      disableBackdropClick,
      disableEscapeKeyDown,
      disableDrag,
      formOnly,
      maxWidth,
    } = this.props;

    // @ts-ignore
    const isOpen = this?.props?.[name]?.isOpen;
    let modalActions,
      modalContent = null;

    // @ts-ignore
    if (this?.props?.children?.length) {
      // @ts-ignore
      modalActions = this?.props?.children?.filter((it: any) => it?.props?.className?.includes('actions'));
      // @ts-ignore
      modalContent = this?.props?.children?.filter((it: any) => it?.props?.className?.includes('body'));
    } else {
      modalContent = this?.props?.children;
    }

    const modalContainer = formOnly ? document.querySelector('div.properties, .Document-Upload div.Form-Content') : null;

    return (
      <Dialog
        container={modalContainer}
        className={`react-root ${className}`}
        fullScreen={fullScreen}
        PaperComponent={fullScreen || disableDrag ? Paper : this.props.PaperComponent || PaperComponent}
        fullWidth={fullWidth}
        open={isOpen || false}
        onClose={(event, reason) => {
					if (
						(disableBackdropClick && reason === 'backdropClick')
					) {
						return;
					}
					this.handleClose()
				}}
        aria-labelledby="form-dialog-title"
        maxWidth={maxWidth}
        disableEscapeKeyDown={disableEscapeKeyDown}
        disableEnforceFocus
        disableRestoreFocus
				disableAutoFocus={true}
        style={{ position: 'absolute' }}
				slotProps={{
					paper: {
						counter: this.state.instanceCounter,
						style: { pointerEvents: 'auto' },
					}
				}}
      >
        {title && (
          <DialogTitle
            id={`form-dialog-title${this.state.instanceCounter}`}
            sx={fullScreen || disableDrag ? null : { cursor: 'move' }}
          >
            {title}
          </DialogTitle>
        )}
        <DialogContent>{modalContent}</DialogContent>

        <DialogActions>
          {modalActions && modalActions}
          {!modalActions && !hideActionButtons && (
            <React.Fragment>
              <Button
                color="primary"
                label={window.Alfresco.messages.global['button.close']}
                onClick={this.handleClose}
                variant="text"
              />
              {onSubmit && (
                <Button
                  color="primary"
                  label={window.Alfresco.messages.global['button.ok']}
                  onClick={this.handleSubmit}
                  variant="text"
                />
              )}
            </React.Fragment>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state: any, props: { reducerPath?: string[] }) => {
  if (!state) return {};
  const retProps = props.reducerPath ? path(props.reducerPath, state) : state?.modal;
  return retProps || {};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ toggleModal }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
